<script setup>
import {computed} from 'vue'
import PreviousConferenceStatCard from '@/components/previous-conference/PreviousConferenceStatCard'

const props = defineProps({
    previousConference: {
        type: Object,
        required: true,
    },
})

/**
 * Input example: rawValue = 251, label = "Participants", icon = "users", suffix = ""
 * Output example: { value: "251", label: "Participants", icon: "users" }
 */
function createStat(rawValue, label, icon, suffix = '') {
    if (rawValue === null || typeof rawValue === 'undefined') {
        return null
    }

    return {
        value: `${rawValue}${suffix}`,
        label,
        icon,
    }
}

const stats = computed(() => {
    return [
        createStat(props.previousConference.number_of_participants, 'Participants', 'users'),
        createStat(props.previousConference.number_of_students, 'Students', 'graduation', '%'),
        createStat(props.previousConference.number_of_academics, 'Academics', 'building', '%'),
        createStat(props.previousConference.number_of_corporate_professionals, 'Corporate', 'briefcase', '%'),
        createStat(props.previousConference.switzerland_percentage, 'Switzerland', 'swiss-flag', '%'),
        createStat(props.previousConference.europe_percentage, 'European Countries', 'europe-network', '%'),
        createStat(props.previousConference.overseas_percentage, 'Overseas Countries', 'globe', '%'),
        createStat(props.previousConference.number_of_posters, 'Scientific Posters', 'poster'),
        createStat(props.previousConference.number_of_exhibitors, 'Exhibitors', 'exhibitor-stand'),
    ].filter(Boolean)
})
</script>

<template>
    <section v-if="stats.length > 0" class="space-y-5">
        <div>
            <h2 class="font-heading text-2xl font-semibold text-slate-900">Highlights at a Glance</h2>
            <div class="mt-3 h-1 w-16 bg-teal-700"></div>
        </div>

        <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
            <PreviousConferenceStatCard
                v-for="stat in stats"
                :key="stat.label"
                :value="stat.value"
                :label="stat.label"
                :icon="stat.icon" />
        </div>
    </section>
</template>

<style scoped></style>
